import { render, staticRenderFns } from "./seguros.vue?vue&type=template&id=3d2e698f&"
import script from "./seguros.vue?vue&type=script&lang=js&"
export * from "./seguros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports